import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/security/profiles';

export default {
    getProfiles() {
        return Api().get(RESOURCE_NAME)
            .catch((err) => errorHandler(err, null));
    },
    getProfile(id) {
        return Api().get(`${RESOURCE_NAME}/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    createProfile(data) {
        return Api().post(RESOURCE_NAME, data)
            .catch((err) => errorHandler(err, null));
    },
    updateProfile(id, data) {
        return Api().put(`${RESOURCE_NAME}/${id}`, data)
            .catch((err) => errorHandler(err, null));
    },
    deleteProfile(id) {
        return Api().delete(`${RESOURCE_NAME}/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    applyToEmployee(employeeId, profileId) {
        return Api().post(`/api/employees/${employeeId}/apply_profile`, { profileId })
            .catch((err) => errorHandler(err, null));
    },
}
